import { memo } from 'react'
import { Grid, Typography } from '@material-ui/core'

import { useStyles } from './styles'

const SUCCESS_TEXT =
   'El proceso de registro se realizó correctamente. Sin embargo, los siguientes usuarios no pudieron registrarse:'
const ERROR_TEXT = 'El proceso de registro no fue exitoso. Se encontraron los siguientes inconvenientes:'

const ObservationsList = ({ data, didAllFail }) => {
   const classes = useStyles()

   return (
      <Grid container direction="column" className={classes.root}>
         <Typography variant="body2">{didAllFail ? ERROR_TEXT : SUCCESS_TEXT}</Typography>
         <Grid container className={classes.list}>
            {data?.failed?.map(item => (
               <Grid container key={item?.email} alignItems="flex-start">
                  <Grid item xs={6}>
                     <Typography variant="body2">
                        <b>{item?.email}</b>
                     </Typography>
                  </Grid>
                  <Grid item xs={6}>
                     <Typography variant="body2" component="span" className={classes.reason}>
                        {item?.reason}
                     </Typography>
                  </Grid>
               </Grid>
            ))}
         </Grid>
         <Typography variant="body2">
            Por favor, verifique la información de estos usuarios y vuelva a intentar registrarlos.
         </Typography>
      </Grid>
   )
}

export default memo(ObservationsList)
